import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

import { getRunnerVehiclePhotoMode } from "../../../lib/conciergeFeature";
import { SESSIONS_POLL_INTERVAL_MS } from "../constants";

export const vehiclePhotoConfigurationQuery = gql`
  query VehiclePhotoConfiguration($brandingKey: String!) {
    installationByBrandingKey(brandingKey: $brandingKey) {
      facility {
        id
        featureFacilityProviderConfigurations {
          id
          configuration
          feature {
            name
          }
          provider {
            name
          }
        }
      }
    }
  }
`;

export default function useVehiclePhotoMode({ facility, brandingKey }) {
  const { data } = useQuery(vehiclePhotoConfigurationQuery, {
    variables: { brandingKey },
    skip: !brandingKey,
    pollInterval: SESSIONS_POLL_INTERVAL_MS,
    fetchPolicy: "network-only",
  });

  const refreshedFacility = data?.installationByBrandingKey?.facility;
  return getRunnerVehiclePhotoMode(refreshedFacility ?? facility);
}
